import React from "react";
import Select from "react-select";
import ErrorIcon from "assets/images/errIcon.png";
import TextInfo from "components/TextInfo";

export default function CustomSelect({
                                        onChange,
                                        filterDiacritics,
                                        options,
                                        value,
                                        placeholder,
                                        textInfoTitle,
                                        hoverText,
                                        isError,
                                        id,
                                        name,
                                        labelDescription,
                                        obligatoriu,
                                        isDisabled
}) {
   const defaultValue = (options, value) => {
      return options ? options.find(option => option.value === value) : "";
   };

   const normalStyle = {
      control:  (styles, { data, isDisabled, isFocused, isSelected }) => ({
         ...styles,
         backgroundColor: isDisabled ? "#f5f5f5" : "white",
         color: isDisabled ? "#ccc" : isSelected ? "#000" : isFocused ? "#000" : "#000",
         cursor: isDisabled ? "not-allowed" : "default",
         border: "1px solid #a2a2a2",
         borderRadius: "7.2px",
         minHeight: "49px"
      }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
         return {
            ...styles,
            backgroundColor: isDisabled ? "#f5f5f5" : isSelected ? "#f5f5f5" : isFocused ? "#f5f5f5" : null,
            color: isDisabled ? "#ccc" : isSelected ? "#000" : isFocused ? "#000" : "#000",
            cursor: isDisabled ? "not-allowed" : "default",
         };
      },
      singleValue: (styles, { data }) => ({ ...styles, color: "#000" }),
   };

   const errorStyle = {
      control: styles => ({
         ...styles,
         backgroundImage: `url(${ErrorIcon})`,
         backgroundRepeat: "no-repeat",
         backgroundPosition: "87% 50%",
         backgroundColor: "white",
         border: "1px solid #ff6363",
         minHeight: "49px",
         borderRadius: "7.2px",
      }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
         return {
            ...styles,
            backgroundColor: isDisabled ? null : isSelected ? "#f5f5f5" : isFocused ? "#f5f5f5" : null,
            color: isDisabled ? "#ccc" : isSelected ? "#000" : isFocused ? "#000" : "#000",
            cursor: isDisabled ? "not-allowed" : "default",
         };
      },
      singleValue: (styles, { data }) => ({ ...styles, color: "#000" }),
   };

   return (
      <div className="col-md-12">
         <label htmlFor={name}>
            <div style={{float: "left"}}>{labelDescription} {obligatoriu && <span className="optional"> (obligatoriu)</span>}</div>

            {textInfoTitle && (
                <TextInfo
                    containerClassNames={"float-end mt-3px"}
                    textClassNames={"mb-0 contr-sub d-flex align-items-center"}
                    text=""
                    hoverText={hoverText}
                />
            )}
         </label>
         <Select
            id={id}
            name={name}
            classNamePrefix="react-select"
            value={value ? defaultValue(options, value) : ""}
            onChange={value => onChange(value)}
            options={options}
            placeholder={placeholder}
            styles={isError ? errorStyle : normalStyle}
            isDisabled={isDisabled}
         />
      </div>
   );
}
